// «Zobacz w środku»: ONLY real pages from RELIGIA GOTOWA™ Tom 1 (Gamma Estudio).
// Empty list = section hidden. Add {src, label, title, text} when real Tom 1 pages exist (WebP ~1512×1890).
export const pageSamples: Array<{src: string; label: string; title: string; text: string}> = [];
